import { render, staticRenderFns } from "./LibraryItem.vue?vue&type=template&id=303a9822&"
import script from "./LibraryItem.vue?vue&type=script&lang=js&"
export * from "./LibraryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports